import {Component} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ngbd-modal-content',
  templateUrl: './app-store-info-modal.component.html',
  styleUrls: ['./app-store-info-modal.component.scss']
})

export class AppStoreInfoModalContent {
  constructor(public activeModal: NgbActiveModal) {
  }
}
